import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    if (this.element.parentElement.id === "nested_modal") {
      this.principalModal = document.getElementById("modal").children[0];
      this.principalModalInitialActions = this.principalModal.dataset.action;
      this.principalModal.removeAttribute("data-action");
    }
    setTimeout(() => {
      this.element.dataset.complete = true;
    }, 50);
  }

  hideModal() {
    const parentTag = this.element.parentElement.tagName;
    const isParentTurboFrame = parentTag === "TURBO-FRAME";
    this.element.dataset.complete = false;
    setTimeout(() => {
      if (isParentTurboFrame) {
        this.element.parentElement.removeAttribute("src");
      }
      this.element.remove();
      if (this.principalModal) {
        this.principalModal.dataset.action = this.principalModalInitialActions;
      }
    }, 300);
  }

  closeOnClick(event) {
    if (event && this.element.children[0].contains(event.target)) {
      return;
    }
    this.hideModal();
  }
}
